// The parent element of this component needs to have a relative className
// because of the absolute positioning of these shapes

import { cn } from '#app/utils/misc.tsx'

// Additionally, if there are sibling elements to this component that need
// these shapes should be positioned underneath of, the sibling should also have
// a relative ClassName

interface Props {
  circleClassNames?: string
  triangleClassNames?: string
}

export default function OnboardingShapes({
  circleClassNames,
  triangleClassNames,
}: Props) {
  return (
    <>
      <div
        className={cn('absolute top-14 -left-20 w-[134px]', circleClassNames)}
      >
        <img src="/img/decorative/signup-shape-1.svg" alt="" />
      </div>
      <div
        className={cn('absolute top-0 -right-32 w-[127px]', triangleClassNames)}
      >
        <img src="/img/decorative/signup-shape-2.svg" alt="" />
      </div>
    </>
  )
}
